export default __webpack_public_path__ + "static/media/151-maps-and-flags-5.a074805e.png";